import { Injectable } from '@angular/core';
import { RestAPIService } from '../rest-api.service';
@Injectable({
  providedIn: 'root'
})
export class VisaUrlService {
  private readonly visaBaseApi = '/api/visadetails';
  private readonly user = '/user';
  private readonly userId_param = 'userId'
  constructor(private restApi:RestAPIService) { }
  getBaseUrl(){
    return this.visaBaseApi;
  }
  getUserUrl(userId) {
    return this.visaBaseApi + this.user
      + '?' + this.userId_param + '=' + userId
  }
  getByFieldUrl(field){
    return this.visaBaseApi+ this.getByField(field)
  }
  private getByField(field){
    return '/'+field;
  }
}